import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HTMLEntities } from '../models/HTMLEntities';
import { UtilService } from '../services/util.service';
import { Device } from '../models/devicetype';

@Component({
  selector: 'app-text-reader',
  templateUrl: './text-reader.component.html',
  styleUrls: ['./text-reader.component.css']
})
export class TextReaderComponent implements OnChanges, OnDestroy, OnInit {

  synth;
  pauseValue: boolean = false;
  @Input() htmltext: string;
  @Input() textarea: any;
  @Input() hasMedia: boolean;
  valueTxt;
  revisedText: string;  
  public get isAndroid() : boolean {
    return this.util.getDeviceType() === Device.Android;
  }
    
  constructor(private cdr: ChangeDetectorRef, private toaster: ToastrService, private util: UtilService) {

  }

  ngOnInit(): void {
    this.synth = window.speechSynthesis;
    window.addEventListener('beforeunload', () => {
      this.stopReading();
    });
    this.valueTxt = this.htmltext;
  }

  ngOnDestroy(): void {
    this.stopReading();
    window.removeEventListener('beforeunload', () => {
      this.stopReading();
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('htmltext' in changes) {
      try {
        this.stopReading();
        this.valueTxt = this.htmltext;
      }
      catch (e) {
        this.toaster.warning(e.message)
      }
    }
  }

  stopReading(): void {
    try {
      if (this.synth?.speaking) {
        this.synth.cancel();
      }
      let highlightDiv = document.getElementById('highlighted-word');
      highlightDiv.style.fontSize = 'inherit';
      highlightDiv.style.fontWeight = 'inherit';
      if(this.pauseValue)
        this.pauseValue = false
    }
    catch (e) {
      console.log('error when stopping text reader:', e);
    }
  }

  read() {
    if (this.synth.speaking)
      return;

    this.revisedText = HTMLEntities.cleanuphtml(this.valueTxt);
    let spiltLength = 4000;
    const chunks = this.isAndroid ? this.chunkText(this.revisedText, spiltLength) : [this.revisedText];
    if (this.valueTxt !== '') {
      this.speakChunksSequentially(chunks, spiltLength);
    }
    this.cdr.detectChanges();
  }

  pause(): void {
    if (this.synth.speaking) {
      this.synth.pause();
      this.togglePause();
      this.cdr.detectChanges();
    }
  }

  continue() {
    this.synth.resume();
    this.togglePause();
    this.cdr.detectChanges();
  }
  private togglePause() {
    this.pauseValue = !this.pauseValue
  }

  private highlight(index: number, charLength: number) {
    if(!this.isAndroid){
      let rep = this.valueTxt.substring(index, index + charLength);
      let rep2 = `<span id='highlighted-word' class="highlight">${rep}</span>`;
  
      let val = this.valueTxt.substring(0, index) + rep2 + this.valueTxt.substring(index + charLength);
      this.textarea.innerHTML = val;
      let highlightDiv = document.getElementById('highlighted-word')
      if (!this.isScrolledIntoView(highlightDiv))
        highlightDiv?.scrollIntoView();
    }    
  }

  private isScrolledIntoView(el) {
    let rect = el.getBoundingClientRect();
    let elemTop = rect.top;
    let elemBottom = rect.bottom;
    let isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    return isVisible;
  }

  private chunkText(text: string, chunkSize: number): string[] {
    const chunks: string[] = [];
    let start = 0;
    while (start < text.length) {
      let end = start + chunkSize;
      chunks.push(text.slice(start, end));
      start = end;
    }
    return chunks;
  }

  private speakChunksSequentially(chunks: string[], splitLength, index: number = 0): void {
    if (index >= chunks.length) {
      this.stopReading();
      return;
    }
    let mainStartIndex = splitLength * index;
    const utterThis = new SpeechSynthesisUtterance(chunks[index]);
    this.setVoice(utterThis);

    utterThis.onboundary = (event) => {
      if (event.name === 'word' && !this.hasMedia) {
        this.highlight(event.charIndex + mainStartIndex, event.charLength);
      }
    };

    utterThis.onend = () => {
      index++;
      this.speakChunksSequentially(chunks, splitLength, index);
      this.cdr.detectChanges();
    };

    utterThis.onerror = (event) => {
      this.synth.cancel();
      this.cdr.detectChanges();
      console.log('text-to-speech error:', event);
    };

    this.synth.speak(utterThis);
  }
  private setVoice(utterThis) {
    const voices = window.speechSynthesis.getVoices();
    let voice = voices.find(voice => voice.name === 'Microsoft Hazel - English (United Kingdom)');
    if (voice) {
      utterThis.voice = voice;
      utterThis.lang = 'en-GB';
    }
    else {
      voice = voices.find(voice => voice.name === 'Microsoft Susan - English (United Kingdom)');
      if (voice) {
        utterThis.voice = voice;
        utterThis.lang = 'en-GB';
      }
      else {
        voice = voices.find(voice => voice.name === 'Microsoft Mark - English (United States)');
        if (voice) {
          utterThis.voice = voice;
          utterThis.lang = 'en-US';
        }
        else {
          utterThis.voice = voices[0];
        }
      }
    }
    return utterThis.voice;
  }
}
